import { Controller } from 'stimulus';
import getControllerForElement from '@/helpers/getControllerForElement';

class VideoOverlayController extends Controller {
  onToggleClick() {
    this.toggleModal();
  }

  toggleModal() {
    const target = this.data.get('modal-id');
    const $modal = $(target);

    $modal.modal('toggle');

    $modal.on('shown.bs.modal', () => {
      const videoElement = this.element.querySelector('.video');

      getControllerForElement(this.application, videoElement, 'video')
        .then((controller) => {
          controller.loadVideo();
        });
    });
  }
}

VideoOverlayController.targets = [
  '',
];

export default VideoOverlayController;
